import React from 'react';
import { Routes } from '@packages/enums';
import { Breadcrumb as AntBreadcrumb } from 'antd';
import classNames from 'classnames';
import { Link, useMatches, type UIMatch } from 'react-router';
import Styles from './Styles.module.scss';
import { Icon } from '@ui/assets/icons/IconWrapper';

type CrumbHandle = {
    crumb?: React.ReactNode;
    crumbText?: string;
};

export default function Breadcrumb() {
    const matches = useMatches() as UIMatch<any, CrumbHandle>[];

    const breadCrumbMatched = matches.filter(match => {
        const crumb = match.handle?.crumb;
        if (!crumb) return false;
        return crumb !== 'Home';
    });
    const breadcrumbItems = [
        {
            title: (
                <Link
                    to={Routes.HOME}
                    className={classNames('flex items-center gap-1', Styles.homeButton)}
                    data-testid="breadcrumb-home"
                >
                    <div className="flex h-[22px] items-center justify-center gap-1">
                        <Icon
                            name="HomeGray"
                            className="mb-[2px]"
                        />
                        <span>Home</span>
                    </div>
                </Link>
            ),
        },
        ...breadCrumbMatched.map((match, index) => {
            // Safely convert crumb to string for data-testid
            const crumbValue = match.handle.crumb;
            const crumbString =
                typeof crumbValue === 'string' || typeof crumbValue === 'number'
                    ? String(crumbValue)
                    : React.isValidElement(crumbValue)
                      ? `crumb-element-${index}`
                      : `crumb-${index}`;
            const testId = `breadcrumb-${crumbString.toLowerCase().replace(/\s+/g, '-')}`;

            return {
                title:
                    index === breadCrumbMatched.length - 1 ? (
                        <span
                            className={classNames('font-bold! text-[#393939]!', Styles.homeButton)}
                            data-testid={testId}
                        >
                            {match.handle.crumb}
                        </span>
                    ) : (
                        <Link
                            to={match.pathname}
                            className={classNames(Styles.homeButton)}
                            data-testid={testId}
                        >
                            {match.handle.crumb}
                        </Link>
                    ),
            };
        }),
    ];

    // Don't show breadcrumb on dashboard
    // if (matches.length === 2 && matches[1].pathname === '/') {
    //     return null;
    // }

    return (
        <div className="sticky top-0 z-50 bg-[#F9FAFB] px-6 py-3">
            <AntBreadcrumb
                items={breadcrumbItems}
                className={Styles.breadCrumb}
                separator={<Icon name="ChevronRight" />}
            />
        </div>
    );
}
